import React, { useState } from "react";
import "./index.css";
import { Button, Stack } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import QuantityCard from "../common/quantityCard";
import { NavLink } from "react-router-dom";
import { formatDateWithMonth } from "../../../../utils/helperFunction";
import { quickincidentdata } from "../../../../redux/slice/QuickReportSlice";
import { StatusCode } from "../../../../services/helper";
import ButtonLoader from "../../../../components/Common/ButtonLoader";
import { usePic } from "../../../../context/PicProvider";
import ProductDetailsButtonView from "../common/ProductDetailsButtonView";

const OnlineQuickPageThree = () => {
  const { form_Data, quickAddItemFormData, status, quichReportData } =
    useSelector((state) => state.QUICKREPORT);
  const dispatch = useDispatch();
  const { setSuccessPopup } = usePic();
  const [quantityArray, setQuantityArray] = useState(
    quickAddItemFormData.formDataArray
  );
  const postApiData = async (e) => {
    e.preventDefault();
    const newData = quickAddItemFormData?.formDataArray?.map(
      ({ item, quantity, personOfTreatment }) => ({
        full_name: personOfTreatment.value,
        used_quantity: Number(quantity.value),
        title: item.value,
        product_id: item?.productId,
      })
    );
    const payload = {
      first_name: form_Data?.firstName?.value,
      last_name: form_Data?.lastName?.value,
      country_code: form_Data?.phoneNumberCode?.value,
      contact_number: form_Data?.phoneNumber?.value,
      email: form_Data?.email?.value,
      category_of_incident: form_Data?.category?.value,
      classification: form_Data?.classification?.value,
      incident_date: form_Data?.date?.value,
      incident_time: form_Data?.time?.value,
      description: form_Data?.summary?.value,
      item_used: newData,
      kit_id: quichReportData?.kit_data?._id,
      company_id: quichReportData?.kit_data?.company_id,
      location_of_incident: quichReportData?.kit_data?.location_name,
      area_of_incident: quichReportData?.kit_data?.area,
    };

    try {
      const response = await dispatch(quickincidentdata(payload));
      const result = response?.payload;
      if (result?.status === 200) {
        setQuantityArray([]);
        setSuccessPopup({
          open: true,
          title: "Submission Complete",
          primaryText: "Done",
          message: "Your report has been submitted successfully.",
          primaryURL: "/standardwithquickreport",
          child: null,
        });
      }
    } catch (error) {
      console.error("Error submitting the incident data:", error);
    }
  };

  return (
    <div className="quickthreepage flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <h6 className="mb-0 fw-bold text-center">Reported By</h6>
        <div className="summaryinfocontainer">
          <div className="incidentmadeinfo">
            <hr />
            <Stack gap={2}>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Name:</h5>
                <span className="text-break">
                  {form_Data?.firstName?.value} {form_Data?.lastName?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Contact Number: </h5>
                <span>
                  {form_Data.phoneNumberCode.value}{" "}
                  {form_Data.phoneNumber.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Email: </h5>
                <span className="text-break">{form_Data.email.value}</span>
              </div>
            </Stack>
          </div>
          <div className="incidentmadeinfo mt-4">
            <h6 className="fw-bold text-center"> Type of Incident</h6>
            <hr />
            <Stack gap={2}>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Category: </h5>
                <span className="text-break">{form_Data.category.value}</span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Classification: </h5>
                <span className="text-break">
                  {form_Data?.classification?.value}
                </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Date: </h5>
                <span className="text-break">{form_Data.date.value} </span>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-1">
                <h5 className="mb-0">Time: </h5>
                <span className="text-break">{form_Data.time.value} </span>
              </div>
            </Stack>
          </div>
          <div className="incidentmadeinfo mt-4">
            <h6 className="fw-bold text-center">Summary of Incident</h6>
            <hr />
            {form_Data.summary.value ? (
              <div className="overflow-y-auto" style={{ maxHeight: "400px" }}>
                <p className="text-break">{form_Data.summary.value} </p>
              </div>
            ) : (
              <p className="mb-0">No summary found</p>
            )}
          </div>
          <div className="incidentmadeinfo mt-4">
            <h6 className="fw-bold text-center">
              First Aid Kit and Location Details
            </h6>
            <hr />
            <h6 className="quickheading mb-3 fw-bold text-break">
              <span> {quichReportData?.kit_data?.brand}</span>
              <span className="ms-2">
                {quichReportData?.kit_data?.model_number}
              </span>
              <div> {quichReportData?.kit_data?.product_name}</div>
            </h6>
          </div>
          <ProductDetailsButtonView />
          {quantityArray.length > 0 && (
            <QuantityCard
              setData={setQuantityArray}
              attr={""}
              DataArr={quantityArray}
            />
          )}
        </div>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink to="/quickreportworkplace" className={"nav-link"}>
          <Button variant="dark" className="fw-bold h-100">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            type="submit"
            onClick={(e) => postApiData(e)}
            className="button_custom text-black fw-bold d-flex align-items-center justify-content-center"
            disabled={status === StatusCode.LOADING}
          >
            {status === StatusCode.LOADING ? <ButtonLoader /> : "Submit Report"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnlineQuickPageThree;
